import { withLocalState } from 'pyradux';

import SellPaymentsPanelContainer from './SellPaymentsPanel.container';
import reducer from './SellPaymentsPanel.reducer';
import SellPaymentsPanelSagas from './SellPaymentsPanel.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'sellPaymentsPanel',
  sagas: [SellPaymentsPanelSagas],
};

export default withLocalState(withLocalStateOptions, SellPaymentsPanelContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/index.js